export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: '返回',
            backToProject: '返回首页',
            editProjectName: '编辑项目名称',
            folderUncategorized: '未分类',
            switchFolder: '切换文件夹',
            moveProjectConfirmTitle: '移动项目',
            moveProjectConfirmMessage: '确定将当前项目移动到所选文件夹吗？',
            moveProjectConfirmOk: '确定移动',
            moveProjectConfirmCancel: '取消',
            moveProjectSuccess: '项目已移动',
            moveProjectFailed: '项目移动失败',
            switchProject: '切换项目',
            recentProjects: '最近项目',
            noRecentProjects: '暂无最近项目',
            browseAllProjects: '浏览全部项目',
            updateProjectNameSuccess: '项目名称更新成功',
            updateProjectNameFailed: '项目名称更新失败',
            defaultTitle: '无标题文档',
            editTitle: '点击编辑标题',
            clickToEditName: '点击编辑',
            screen: {
                single: '单屏',
                split: '分屏',
            },
            aiHiro: 'Hiro',
            save: '保存',
            saveOptions: '保存选项',
            saveToFolder: '保存到文件夹',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            export: '导出',
            exportAll: '导出全部',
            exportSuccess: '导出成功',
            exportFailed: '导出失败',
            settings: '设置',
            share: '分享',
            sharePermissionDenied: '只有项目创建者可以分享',
            readOnlyWarning: '权限不足：您只有只读权限',
            emptyContentError: '文档内容为空，无法保存',
            updateTitleSuccess: '标题更新成功',
            updateTitleFailed: '更新标题失败',
            importing: '正在导入文档...',
            importSuccess: '导入成功',
            importFailed: '导入失败',
            exportUpgradeTip: '导出功能仅限付费用户 ',
            upgradeLink: '立即升级',
        },
        userPreferences: {
            title: '设置',
            taskDisclosure: '交底书',
            taskPatentDraft: '专利申请',
            taskProsecution: '审查意见答复',
            personalization: '个性化',
            description: '保存长期生效的 Markdown 规范，用于指导后续{taskType}任务。',
            placeholder: '在这里输入你的执行规范，例如：\n\n# 执行步骤\n\n- 先分析需求，再给出方案\n- 输出前检查事实和格式',
            saving: '保存中...',
            saveSuccess: '设置已保存',
            saveFailed: '设置保存失败',
            loadFailed: '设置加载失败',
            closeConfirmTitle: '放弃修改',
            closeConfirmMessage: '当前设置尚未保存，确定关闭吗？',
            switchConfirmMessage: '当前设置尚未保存，确定切换任务类型并放弃修改吗？',
            closeConfirmOk: '放弃修改',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: '添加来源',
            createDocument: '创建文档',
            selectDocumentType: '选择文档类型并创建',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: '空白文档',
            placeholder: '创建空白文档',
            title: '空白文档',
            description: '创建一个空白文档，从头开始撰写',
            action: '创建空白文档',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: '关闭其他',
            closeAll: '关闭所有',
            files: '文件',
            originalText: '原文',
        },
    },
};
